/**
 * Renders a chat-history "X ago"-style relative timestamp:
 *  - `just now` when within 60s of `now`
 *  - `Nm ago` for the next hour
 *  - `Nh ago` for the next 24h
 *  - `Nd ago` up to 7 days
 *  - localized absolute date thereafter
 *
 * `now` is injected for deterministic tests and Storybook snapshots
 * (see `.storybook/fixedClock.js`). The default reads the live clock so
 * production callers do not need to plumb it through.
 */
export function formatRelativeTime(date: Date, now: Date = new Date()): string {
  const diffMs = now.getTime() - date.getTime()
  const diffMinutes = Math.round(diffMs / 60_000)

  if (diffMinutes < 1) return 'just now'
  if (diffMinutes < 60) return `${diffMinutes}m ago`

  const diffHours = Math.round(diffMinutes / 60)
  if (diffHours < 24) return `${diffHours}h ago`

  const diffDays = Math.round(diffHours / 24)
  if (diffDays < 7) return `${diffDays}d ago`

  return date.toLocaleDateString()
}
